import ApiService from '@/services/core/api.service'

const PendingAccountService = {
  async get (query) {
    return ApiService.get(`agent/pending-accounts?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/pending-accounts', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/pending-accounts/${payload.id}`, payload)
  }
}

export default PendingAccountService
